
export default {
    layout(context) {
        const isAgent = context?.$cookie?.get('ia')
        if (isAgent) {
            return 'agent'
        }
        return 'default'
    },
    props: {
        error: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            otherError: 'An error occurred',
        }
    },
    head() {
        const title =
            this.error.statusCode === 404 ? this.pageNotFound : this.otherError
        return {
            title,
        }
    },
}
